(function ($) {
    $(document).ready(function () {
        $('.gallery-slider .slider-wrapper .slider-box').slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            arrows: false,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'ease',
            pauseOnHover: false,
        });

    });
})(jQuery);